import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router";
import { Input, Label, Close, Button, Utils } from "arv-reactcomponents";
import BodyOverlay from "../BodyOverlay";
import { getFilterUrl, somethingWentWrong, clearedUrl } from "../../utils";

@withRouter
@inject("ProductStore")
@observer
class SelectedFilters extends Component {
  static filterAppliedText(filters) {
    const { length } = filters;
    return `${length} filter${length > 1 ? "s" : ""} applied`;
  }

  constructor(props) {
    super(props);
    this.state = {};
    this.filterClick = this.filterClick.bind(this);
    this.clearAll = this.clearAll.bind(this);
  }

  filterClick(filter) {
    BodyOverlay.show();
    const { pathname, search } = this.props.location;
    const { ProductStore } = this.props;
    const pagePath = `${pathname}${search}`;

    ProductStore.setListingPageNo(1);
    const pathWithPageNo = Utils.setUrlParameter(pagePath, "p", 1);

    const filterUrl = getFilterUrl(filter, filter.mapping, pathWithPageNo);
    const newUrl = `${pathname}?${filterUrl}`;
    ProductStore.getAllProductData(newUrl).then(
      () => {
        BodyOverlay.hide();
      },
      () => {
        BodyOverlay.hide();
        somethingWentWrong();
      },
    );
    this.props.history.push(newUrl);
  }

  clearAll(event) {
    event.preventDefault();
    BodyOverlay.show();
    const { pathname, search } = window.location;
    const { ProductStore } = this.props;
    const newUrl = clearedUrl(pathname, search);
    ProductStore.getAllProductData(newUrl).then(
      () => {
        BodyOverlay.hide();
      },
      () => {
        BodyOverlay.hide();
        somethingWentWrong();
      },
    );
    this.props.history.push(newUrl);
  }

  render() {
    const { selectedFilters } = this.props;
    if (!selectedFilters || !selectedFilters.length) return null;

    return (
      <div className="nw-selectedfilters">
        <ul className="nw-selectedfilters-topbar">
          <li className="nw-selectedfilters-heading">
            {SelectedFilters.filterAppliedText(selectedFilters)}
          </li>
          {/* <li>
            <Button
              onClick={event => this.clearAll(event)}
              className="nw-selectedfilters-clearall"
            >
              Clear All
            </Button>
          </li> */}
        </ul>
        <ul className="nw-selectedfilters-list">
          {selectedFilters.map(filter => (
            <li className="nw-selectedfilters-item" key={filter.displayName}>
              <Label
                className="nw-selectedfilters-label"
                htmlFor={`selected-filter-${filter.displayName}`}
              >
                <Input
                  id={`selected-filter-${filter.displayName}`}
                  type="checkbox"
                  value={filter.value || ""}
                  className="nw-selectedfilters-checkbox"
                  checked={filter.isSelected || false}
                  name={filter.displayName}
                  onChange={() => {
                    this.filterClick(filter);
                  }}
                />
                <span>{filter.displayName}</span>
                <Close
                  onClick={() => {
                    this.filterClick(filter);
                  }}
                  className="nw-selectedfilters-itemclose"
                />
              </Label>
            </li>
          ))}
          {selectedFilters &&
            selectedFilters.length > 1 && (
              <Button
                onClick={event => this.clearAll(event)}
                className="nw-selectedfilters-clearall"
              >
                Clear All
              </Button>
            )}
        </ul>
      </div>
    );
  }
}

SelectedFilters.wrappedComponent.propTypes = {
  selectedFilters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  ProductStore: PropTypes.shape({}).isRequired,
};
export default SelectedFilters;



// WEBPACK FOOTER //
// ./src/component/SelectedFilters/index.js